<!-- <div class="table-container"> -->
<div [class]="containerClass">
  <div class="table-wrapper">
    <table
      class="fip-table"
      mat-table
      [dataSource]="dataSource"
      [ngClass]="isCompact ? 'compact' : ''"
    >
      @for (column of columns; track column) {
        <ng-container [matColumnDef]="column.index">
          <th mat-header-cell *matHeaderCellDef>{{ column.label }}</th>
          @if (column.key === 'actions') {
            <td
              mat-cell
              *matCellDef="let element; let i = index"
              [ngClass]="{ highlight: highlightedRowIndex === element.index }"
            >
              <div class="action-links">
                @for (link of element.actions; track link) {
                  <button
                    mat-icon-button
                    (click)="link.action(element)"
                    [title]="link.label"
                    class="small-icon-button"
                    [disabled]="link.disabled"
                  >
                    <mat-icon>{{ link.icon }}</mat-icon>
                  </button>
                }
              </div>
            </td>
          } @else {
            <td
              mat-cell
              data-cy="table-cell"
              *matCellDef="let element; let i = index"
              class="default"
              [ngClass]="{
                highlight: highlightedRowIndex === element.index,
                'is-placeholder':
                  !element[column.key] ||
                  element[column.key].toString().trim() === '',
              }"
            >
              {{
                element[column.key] &&
                element[column.key].toString().trim() !== ''
                  ? element[column.key]
                  : cellPlaceholder
              }}
            </td>
          }
        </ng-container>
      }

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>

      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        (click)="handleRowClick(row)"
      ></tr>
    </table>
  </div>

  @if (paginated) {
    <mat-paginator
      showFirstLastButtons
      [pageSizeOptions]="pageSizeOptions"
      [pageIndex]="pageIndex"
    >
    </mat-paginator>
  }

  @if (exportable) {
    <div class="flex w-full justify-end">
      <button
        (click)="handleExportClick()"
        class="mr-4 cursor-pointer text-xs text-gray-400 underline"
      >
        Export Data
      </button>
    </div>
  }
</div>
